module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABDElEQVR4AeXWgUYEURSH8W9kwMwCwr5K6i0KpEIkoJREiUFvEKASJSgiCEh6gWqA9AYblCkB/AO7HO64cw8D9ncB+JgZc89hGg3Y5JKaQwC2eOOCZXKSDDnlDyFEBcAeQogRFQUdrdMgFAiNY2tE5dwgFAqZc0tBOwY8o04hUVPS6g51DokHMoJWUFJI7BBQ8p0capjFAvZRckicYDHDyBX6IcdYQK6QWMI4dofOMJ7coVeMj0hojqrlHGE0kVBED6F396MdYDy6X/ZLT59/3h1axMj4dIV+yXv6aaHky3+NWKvJoV1aXPuvWqv0Xv7+cXRPQUTGhmdAhg05947s8BJxNVkitqnNEjFN/gHw7z/TcdQxdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/kpi.png
// module id = 207
// module chunks = 1